export default __webpack_public_path__ + "static/media/118.6dcaa201.png";